import { render } from "./patient-show.vue?vue&type=template&id=b06979ac&scoped=true"
import script from "./patient-show.vue?vue&type=script&lang=js"
export * from "./patient-show.vue?vue&type=script&lang=js"

import "./patient-show.vue?vue&type=style&index=0&id=b06979ac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b06979ac"]])

export default __exports__